/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Failure_Not_ReadyInputs */

const en_sync_failure_not_ready = /** @type {(inputs: Sync_Failure_Not_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing was sent: something Business Central needs is missing. See below what, fix it, then send again.`)
};

/**
* | output |
* | --- |
* | "Nothing was sent: something Business Central needs is missing. See below what, fix it, then send again." |
*
* @param {Sync_Failure_Not_ReadyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const sync_failure_not_ready = /** @type {((inputs?: Sync_Failure_Not_ReadyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Failure_Not_ReadyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_sync_failure_not_ready(inputs)
});